import { Image, Box, Skeleton } from '@mantine/core';
import { useState } from 'react';

interface CommonImageProps {
  src?: string | null;
  alt: string;
  size?: number | string;
  className?: string;
  fallbackSrc?: string;
  maxWidth?: number;
}

export function CommonImage({
  src,
  alt,
  size = '100%',
  className,
  maxWidth,
  fallbackSrc = '/images/default-placeholder.jpg',
}: CommonImageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  return (
    <Box
      style={{
        width: size,
        height: size,
        position: 'relative',
        maxWidth: maxWidth,
        maxHeight: maxWidth,
        margin: maxWidth ? '0 auto' : undefined,
      }}
      className={className}
    >
      {isLoading && (
        <Skeleton
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        />
      )}
      <Image
        src={hasError ? fallbackSrc : src || fallbackSrc}
        alt={alt}
        loading="lazy"
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setHasError(true);
          setIsLoading(false);
        }}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          aspectRatio: '1/1',
        }}
      />
    </Box>
  );
}
